/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Agents_OverlineInputs */

const en_mk_sol_agents_overline = /** @type {(inputs: Mk_Sol_Agents_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The agent line-up`)
};

const id_mk_sol_agents_overline = /** @type {(inputs: Mk_Sol_Agents_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Susunan agen`)
};

/**
* | output |
* | --- |
* | "The agent line-up" |
*
* @param {Mk_Sol_Agents_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_agents_overline = /** @type {((inputs?: Mk_Sol_Agents_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Agents_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_agents_overline(inputs)
	return en_mk_sol_agents_overline(inputs)
});